import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { change, Field, Fields, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { searchContacts } from "MODULES/parts/actions";
import {
  form,
  Form as AppForm,
  Select,
  FormInput
} from "MODULES/shared/components/Forms";
import SearchCompanyField from "MODULES/companies/shared/FindOrCreateCompanyToggle/SearchCompanyField";
import * as actions from "MODULES/companies/actions/actions";
import { COMPANY, COMPANY_ID, CONTACT_ID } from "APP_ROOT/constants";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import { contactSelectList } from "MODULES/companies/helpers";
import { PORTAL_PURCHASE } from "MODULES/PurchaseOrders/constants";
import { properCase } from "LIB/formatters/text";
import { WEBSITE } from "MODULES/companies/constants";
import RestrictedEntityWarning from "MODULES/companies/shared/components/RestrictedEntityWarning";
import validate from "./validate";

const FORM_NAME = "editQuote";

export class Form extends React.Component {
  state = {
    selectedCompany: {},
    options: [{ text: "+ Add a Contact", value: "Add" }]
  };

  componentWillMount() {
    if (this.props.quote && this.props.quote.company) {
      this.fetchContactOptions(this.props.quote.company.id);
      this.setState({
        selectedCompany: this.props.quote.company
      });
    }
  }

  fetchContactOptions = companyId => {
    if (companyId) {
      return searchContacts(companyId).then((vals = []) => {
        const opts = contactSelectList(vals, true);

        return this.setState({ options: opts });
      });
    }

    return null;
  };

  render() {
    const { quote, contact, setFieldValue } = this.props;
    const addContact = contact === "Add";
    const portalPurchase = contact === PORTAL_PURCHASE;
    const { options, selectedCompany } = this.state;

    return (
      <AppForm {...this.props}>
        <AppForm.Body>
          <RestrictedEntityWarning company={selectedCompany} allContacts />
          <FormRow>
            <Col md={12}>
              <div className="form-group">
                <Fields
                  names={[COMPANY_ID, CONTACT_ID]}
                  component={SearchCompanyField}
                  selectedCompany={quote && quote.company}
                  onResultSelected={result => {
                    this.fetchContactOptions(result.id);
                    this.setState({
                      selectedCompany: result
                    });
                    setFieldValue([COMPANY, WEBSITE].join("."))(result.website);
                  }}
                  placeholder="Search by typing a company's name or code"
                  required
                />
              </div>
            </Col>
          </FormRow>
          <FormRow>
            <Col md={12}>
              <div className="form-group">
                <Field
                  name={CONTACT_ID}
                  component={Select}
                  options={options}
                  label="Vendor Contact"
                  required
                />
              </div>
            </Col>
          </FormRow>
          {portalPurchase && (
            <FormRow>
              <Col md={12}>
                <div className="form-group">
                  <Field
                    component={FormInput}
                    disabled={get(this.state, "selectedCompany.website")}
                    name="company.website"
                    label={properCase(WEBSITE)}
                    required
                  />
                </div>
              </Col>
            </FormRow>
          )}
          {addContact && (
            <div>
              <FormRow>
                <Col md={12}>
                  <div className="form-group">
                    <Field
                      name="contact.name"
                      component={FormInput}
                      label="Contact Name"
                      required
                    />
                  </div>
                </Col>
              </FormRow>
              <FormRow>
                <Col md={12}>
                  <div className="form-group">
                    <Field
                      name="contact.email"
                      component={FormInput}
                      label="Contact Email"
                      required
                    />
                  </div>
                </Col>
              </FormRow>
            </div>
          )}
        </AppForm.Body>
      </AppForm>
    );
  }
}

Form.propTypes = {
  contact: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  quote: PropTypes.shape({
    company: PropTypes.shape({
      id: PropTypes.number
    })
  })
};

const selector = formValueSelector(FORM_NAME);

export default connect(
  state => ({
    contact: selector(state, CONTACT_ID)
  }),
  (dispatch, ownProps) => ({
    onSubmit: data => dispatch(ownProps.updateQuote(data)),
    setFieldValue: field => val => dispatch(change(FORM_NAME, field, val))
  })
)(
  form({
    form: FORM_NAME,
    validate,
    asyncValidate: actions.validateContact,
    asyncBlurFields: ["contact.email"]
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/Quotes/shared/Edit/Form.jsx